import Vue from 'vue';
import Vuex from 'vuex';
import _orderBy from "lodash.orderby";
import _get from "lodash.get";
import _chunk from "lodash.chunk";
import {router} from './main'

Vue.use(Vuex);
import firebaseFirestore  from 'src/firebase-config';

import * as firebase from 'firebase';

export const store = new Vuex.Store({
  state: {
    currentUser: null,
    userInfo: {},
    workspaces: null,
    invites: null,
    members: null,
    currentWorkspace: null,
    workspaceRetros: [],
    isAdmin: null,
    isOwner: null,
    isUser: null,
    singleRetroLoaded: false,
    workspaceLoaded: false,
    userLoaded: false,
    userInfoLoaded: false
  },
  actions: {
    action_clearData({ commit }) {
      commit('setCurrentUser',null);
      commit('setUserInfo', {});
      commit('setWorkspaces', null);
      commit('setCurrentWorkspace', null);
      commit('setMembers', null);
      commit('setWorkspaceRetros', []);
      commit('setRoles', {
        isAdmin: null,
        isOwner: null,
        isUser: null,
      });
      store.commit('setUserInfoLoaded', false);
      store.commit('setSingleRetroLoaded', false);
      store.commit('setWorkspaceDataLoaded', false);
      store.commit('setUserLoaded', false);
    },
    action_clearDataChangeWorkspace({ commit }) {
      commit('setCurrentWorkspace', null);
      commit('setWorkspaceRetros', []);
    },
    action_subscribeAllWorkspaces:async ({ dispatch, commit, state } )=> {
      const { allWorkspaces,status } = state.userInfo;

      if(!allWorkspaces || state.workspaces !== null ) return;

      const allWorkspacesChunked = _chunk(allWorkspaces,10);
      const workspaces = { };
      const promises = [];
      allWorkspacesChunked.forEach((workspaceChunk)=>{
        const oneProm = firebaseFirestore.collection('workspaces')
          .where(firebase.firestore.FieldPath.documentId(), 'in', workspaceChunk)
          .get()
          .then(async(workspaceSnap) => {
            workspaceSnap.forEach((workspace) => {
              const { id } = workspace;
              workspaces[id]={
                ...workspace.data(),
                id
              };
            });
          });
        promises.push(oneProm);
      });
      await Promise.all(promises);
      commit('setWorkspaces', workspaces);
      dispatch('action_SetCurrentWorkspace',null);

    },
    action_updateCurrentWorkspace({ dispatch, commit, state }, params) {
      firebaseFirestore.collection('workspaces')
        .doc(state.currentWorkspace.id)
        .get()
        .then((snap)=>{
          commit('updateCurrentWorkspace', {
            id:snap.id,
            ...snap.data()
          });
          dispatch('action_getInvites');
        })
    },
    action_SetCurrentWorkspace({ dispatch, commit, state }, params) {
      const workspaceId = (params&&params.workspaceId) || router.currentRoute.params.workspaceId || _get(state,'userInfo.allWorkspaces[0]',null);
      commit('setWorkspaceDataLoaded', false);
      dispatch('action_clearDataChangeWorkspace')
        .then(async () => {
          commit('setCurrentWorkspace', {
            ...state.workspaces[workspaceId],
            id: workspaceId
          });

          await store.dispatch('action_SetRoles')

          await store.dispatch('getWorkspaceRetros',{workspaceId})

          // console.log('%c workspace.uid ='+ workspaceId,'background: #2c2; color: #000');
        })
        .then(() => {
          dispatch('action_getMembers');
          dispatch('action_getInvites');
          dispatch('action_SetRoles');
          dispatch('getWorkspaceRetros', { workspaceId });
        });
    },
     action_getMembers:async({ commit, state, store })=>{
      let allMembers = [...new Set([...state.currentWorkspace.admins, ...state.currentWorkspace.users])];
      allMembers = _chunk(allMembers,10);
      const members = { };
      const promises = [];
      allMembers.forEach((memberChunk)=>{
        const oneProm = firebaseFirestore.collection('usersInfo')
          .where(firebase.firestore.FieldPath.documentId(), 'in', memberChunk)
          .get()
          .then(async(usersSnap) => {
            usersSnap.forEach((user) => {
              const { id } = user;
              members[id]={
                ...user.data(),
                id
              };
            });
          });
        promises.push(oneProm);
      });
      await Promise.all(promises);
      commit('setMembers', members);
    },
    action_getInvites:async({ commit, state, store }) => {
      const allInvites = _chunk(state.currentWorkspace.invites,10);
      const promises = [];
      const invites = { };
      allInvites.forEach((inviteChunk)=>{
        const oneProm = firebaseFirestore.collection('invites')
          .where(firebase.firestore.FieldPath.documentId(), 'in', inviteChunk)
          .get()
          .then(async (invitesSnap) => {
            invitesSnap.forEach((invite) => {
              const { id } = invite;
              invites[id] = {
                ...invite.data(),
                id,
                type: 'invite'
              };
            });
          });
          promises.push(oneProm);
      });

      await Promise.all(promises);
      commit('setInvites', invites);

    },
    action_SetRoles({ commit, state }) {
      const userUuid = state.currentUser.uid;
      const curWorkspace = state.currentWorkspace;

      const isOwner = curWorkspace.payer === userUuid;
      const isAdmin = curWorkspace.admins ? curWorkspace.admins.includes(userUuid) : false;
      const isUser = curWorkspace.users ?  curWorkspace.users.includes(userUuid) : false;
      commit('setRoles', {
        isOwner,
        isAdmin,
        isUser
      });
    },
    getWorkspaceRetros({ commit }, { workspaceId }) {
      return firebaseFirestore
        .collection('workspaces')
        .doc(workspaceId)
        .collection('retros')
        .onSnapshot(async (retrosSnap)=>{
          let retrosData = [];

          retrosSnap.forEach((retro) => {
            retrosData.push({
              ...retro.data(),
              id: retro.id
            });
          });

          retrosData = _orderBy(retrosData, ['createdDate.seconds'], ['desc']);

          commit('setWorkspaceRetros', retrosData);
          store.commit('setWorkspaceDataLoaded', true);
        });
    },
    getSingleRetro({ commit }, params) {
      const workspaceId = params[0];
      const retroId = params[1];
      const retroRef = firebaseFirestore.collection('workspaces').doc(workspaceId).collection('retros').doc(retroId);
      retroRef.get().then((retro) => {

      });
    }
  },
  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = { ...val };
    },
    setUserInfo(state, val) {
      state.userInfo = { ...val };
    },
    setCurrentWorkspace(state, val) {
      state.currentWorkspace = { ...val };
    },
    updateCurrentWorkspace(state, val) {
      state.workspaces[val.id] = { ...val };
      state.currentWorkspace = { ...val };
    },
    setRoles(state, val) {
      state.isAdmin = val.isAdmin;
      state.isUser = val.isUser;
      state.isOwner = val.isOwner;
    },
    setWorkspaceDataLoaded(state, val) {
      state.workspaceLoaded = val;
    },
    setUserLoaded(state, val) {
      state.userLoaded = val;
    },
    setUserInfoLoaded(state, val) {
      state.userInfoLoaded = val;
    },
    setSingleRetroLoaded(state, val) {
      state.singleRetroLoaded = val;
    },
    setWorkspaces(state, val) {
      state.workspaces = val;
    },
    setWorkspaceRetros(state, val) {
      state.workspaceRetros = val;
    },
    setMembers(state, val) {
      state.members = { ...val };
    },
    setInvites(state, val) {
      state.invites = { ...val };
    },
  }
});

firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    store.commit('setCurrentUser', user);
    store.commit('setUserLoaded', true);
    firebaseFirestore
      .collection('usersInfo')
      .doc(user.uid)
      .onSnapshot((doc) => {
        const userInfo = doc.data();
        if (!userInfo) return ;
        store.commit('setUserInfo', userInfo);
        store.commit('setUserInfoLoaded', true);

        // console.log('%c user.uid =' + user.uid, 'background: #222; color: #bada55', doc.data());
      });
  }
});
